import { Injectable, computed, signal } from '@angular/core';

const SHOW_DELAY_MS = 150;
const MIN_VISIBLE_MS = 300;

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly activeCount = signal(0);
  private readonly displayed = signal(false);
  private showTimer?: ReturnType<typeof setTimeout>;
  private hideTimer?: ReturnType<typeof setTimeout>;
  private shownAt = 0;

  readonly visible = computed(() => this.displayed() && this.activeCount() > 0);

  track(): void {
    this.activeCount.update((count) => count + 1);
    this.scheduleShow();
  }

  untrack(): void {
    this.activeCount.update((count) => Math.max(0, count - 1));
    if (this.activeCount() === 0) {
      this.scheduleHide();
    }
  }

  private scheduleShow(): void {
    clearTimeout(this.hideTimer);
    if (this.displayed()) return;

    clearTimeout(this.showTimer);
    this.showTimer = setTimeout(() => {
      if (this.activeCount() > 0) {
        this.shownAt = Date.now();
        this.displayed.set(true);
      }
    }, SHOW_DELAY_MS);
  }

  private scheduleHide(): void {
    clearTimeout(this.showTimer);

    const elapsed = this.displayed() ? Date.now() - this.shownAt : MIN_VISIBLE_MS;
    const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed);

    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      if (this.activeCount() === 0) {
        this.displayed.set(false);
      }
    }, remaining);
  }
}
